import { useContext } from 'react';
import { siteConfigContext } from './site-config-context';

export function useSiteConfig() {
  const siteConfig = useContext(siteConfigContext);
  if (!siteConfig) {
    throw new Error(
      'siteConfigContext value is undefined. Make sure you use the SiteConfigProvider before using the context.'
    );
  }
  return siteConfig;
}
